const { loadScript, loadStyle } = require('./util/loadDependencies');

export default (jsBasePath) => {
	const triggerSlider = () => {
		const elem = document.querySelector('.main-carousel');
		if (is_touch_device() === true) {
			let flkty = new Flickity( elem, {
				// options
				cellAlign: 'left',
				contain: true,
				wrapAround: true,
				imagesLoaded: true,
				draggable: '>1',
				// setGallerySize: false
			});
		} else {
			let flkty = new Flickity( elem, {
				// options
				cellAlign: 'left',
				contain: true,
				wrapAround: true,
				imagesLoaded: true,
				draggable: '>1',
				// setGallerySize: false
			});
		}
		elem.classList.remove("carousel-initial");
		elem.classList.add("carousel-built");

		// detect touch device by bolmaster2
		// source - https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript/4819886#4819886
		function is_touch_device() {
			const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
			const mq = function(query) {
				return window.matchMedia(query).matches;
			};

			if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
				return true;
			}

			// include the 'heartz' as a way to have a non matching MQ to help terminate the join
			// https://git.io/vznFH
			const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
			return mq(query);
		}
	};

	loadStyle(`${jsBasePath}../vendor/flickity/css/flickity.min.css`);
	loadScript(`${jsBasePath}../vendor/flickity/js/flickity.pkgd.min.js`, triggerSlider);
};
